import React from 'react';
import { DISHOP_GREEN, UNIT, WHITE } from '../../../../../../constants';
import { Offer } from '../../../../../../1_types/genericTypes';
import { getTootltipTextFromOffer } from './ProductOfferTooltip.service';

export enum ProductOfferTooltipSize {
  SMALL = 1,
  MEDIUM = 1.5,
  LARGE = 2,
}

type ProductOfferTooltipProps = {
  offer: Offer;
  size?: ProductOfferTooltipSize;
};

export default function ProductOfferTooltip({
  offer,
  size = ProductOfferTooltipSize.SMALL,
}: ProductOfferTooltipProps) {
  return (
    <div
      className='dishop-iso '
      style={{
        position: 'absolute',
        overflow: 'visible',
        top: 0,
        left: '50%',
        transform: 'translate(-50%,-50%)',
        backgroundColor: DISHOP_GREEN,
        color: WHITE,
        fontSize: window.innerWidth <= 320 ? size * 10 : size * 12,
        fontWeight: 500,
        padding: `${(size * UNIT) / 12}px ${(size * UNIT) / 1.25}px`,
        zIndex: 1000,
        borderRadius: '21px',
        whiteSpace: 'nowrap',
      }}
    >
      {getTootltipTextFromOffer(offer)}
    </div>
  );
}
